/**
 * 表单标签列宽工具（前端）：按标签文本估算所需 label-width，避免中文标签折行。
 * 与 Element UI 的 label 样式对齐：字号 14px、box-sizing: border-box、padding: 0 12px 0 0。
 */

// 单个标签文本的渲染宽度（px）：中文/全角按 14px，其余按 7px
export function labelTextWidth(text) {
  let w = 0
  const s = String(text == null ? '' : text)
  for (const ch of s) {
    w += /[\u4e00-\u9fa5\u3000-\u303f\uff00-\uffef]/.test(ch) ? 14 : 7
  }
  return w
}

/**
 * 由标签列表计算所需的 label-width 值（形如 '110px'）。
 * @param {Array} labels 标签文本列表（空值忽略）
 * @param {Object} [options] { min: 下限px, max: 上限px }
 * 取最长标签宽度 + 必填红星与右内边距余量（28px），再收敛到 [min, max]
 */
export function labelWidthOf(labels, options) {
  const opts = options || {}
  const min = opts.min == null ? 110 : opts.min
  const max = opts.max == null ? 220 : opts.max
  let longest = 0
  ;(labels || []).forEach(t => {
    longest = Math.max(longest, labelTextWidth(t))
  })
  return Math.min(max, Math.max(min, Math.ceil(longest) + 28)) + 'px'
}
